import type { SVGProps } from "react";

export type IconName =
  | "sparkles"
  | "calendar"
  | "inbox"
  | "billing"
  | "settings"
  | "search"
  | "plus"
  | "clock"
  | "person"
  | "chevron"
  | "command"
  | "bell"
  | "check"
  | "alert"
  | "document"
  | "medication"
  | "image"
  | "follow"
  | "send"
  | "close"
  | "arrow"
  | "shield"
  | "microphone"
  | "stop"
  | "more"
  | "pencil"
  | "lock"
  | "undo"
  | "lab"
  | "scan"
  | "consult"
  | "upload"
  | "personPlus"
  | "phone"
  | "trash";

const paths: Record<IconName, React.ReactNode> = {
  sparkles: (
    <>
      <path d="m12 3 1.2 3.8L17 8l-3.8 1.2L12 13l-1.2-3.8L7 8l3.8-1.2L12 3Z" />
      <path d="m18.5 13 .7 2.3 2.3.7-2.3.7-.7 2.3-.7-2.3-2.3-.7 2.3-.7.7-2.3Z" />
      <path d="m5.5 13 .9 2.6 2.6.9-2.6.9-.9 2.6-.9-2.6-2.6-.9 2.6-.9.9-2.6Z" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M8 3v4M16 3v4M3 10h18M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" />
    </>
  ),
  inbox: (
    <>
      <path d="M4 5h16l2 9v5a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-5l2-9Z" />
      <path d="M2 14h5l2 3h6l2-3h5" />
    </>
  ),
  billing: (
    <>
      <rect x="4" y="3" width="16" height="18" rx="2" />
      <path d="M8 8h8M8 12h3M15.5 14.5v5M18 17h-5" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.9l.1.1-2.8 2.8-.1-.1a1.7 1.7 0 0 0-1.9-.3 1.7 1.7 0 0 0-1 1.6v.2h-4V21a1.7 1.7 0 0 0-1-1.6 1.7 1.7 0 0 0-1.9.3l-.1.1L4.2 17l.1-.1a1.7 1.7 0 0 0 .3-1.9A1.7 1.7 0 0 0 3 14H2.8v-4H3a1.7 1.7 0 0 0 1.6-1 1.7 1.7 0 0 0-.3-1.9L4.2 7 7 4.2l.1.1A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.6v-.2h4V3a1.7 1.7 0 0 0 1 1.6 1.7 1.7 0 0 0 1.9-.3l.1-.1L19.8 7l-.1.1a1.7 1.7 0 0 0-.3 1.9 1.7 1.7 0 0 0 1.6 1h.2v4H21a1.7 1.7 0 0 0-1.6 1Z" />
    </>
  ),
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-4-4" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  clock: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  person: (
    <>
      <circle cx="12" cy="8" r="4" />
      <path d="M4.5 21a7.5 7.5 0 0 1 15 0" />
    </>
  ),
  chevron: <path d="m9 18 6-6-6-6" />,
  command: <path d="M9 6V5a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3v14a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6Z" />,
  bell: (
    <>
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z" />
      <path d="M10 21h4" />
    </>
  ),
  check: <path d="m5 12 4 4L19 6" />,
  alert: (
    <>
      <path d="M10.3 3.6 2.4 18a2 2 0 0 0 1.8 3h15.6a2 2 0 0 0 1.8-3L13.7 3.6a2 2 0 0 0-3.4 0Z" />
      <path d="M12 9v4M12 17h.01" />
    </>
  ),
  document: (
    <>
      <path d="M6 2h8l4 4v16H6V2Z" />
      <path d="M14 2v5h5M9 12h6M9 16h6" />
    </>
  ),
  medication: (
    <>
      <path d="m7 17 10-10a3.5 3.5 0 1 0-5-5L2 12a3.5 3.5 0 1 0 5 5Z" />
      <path d="m8 6 5 5" />
    </>
  ),
  image: (
    <>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <circle cx="9" cy="10" r="2" />
      <path d="m21 15-5-5L5 20" />
    </>
  ),
  follow: (
    <>
      <path d="M20 11a8 8 0 1 0-2.3 5.7" />
      <path d="M20 5v6h-6" />
    </>
  ),
  send: (
    <>
      <path d="m22 2-7 20-4-9-9-4 20-7Z" />
      <path d="M22 2 11 13" />
    </>
  ),
  close: <path d="M6 6l12 12M18 6 6 18" />,
  trash: (
    <>
      <path d="M4 7h16" />
      <path d="M9 7V4.5h6V7" />
      <path d="m6 7 1 13h10l1-13" />
      <path d="M10 11v5.5M14 11v5.5" />
    </>
  ),
  arrow: (
    <>
      <path d="M5 12h14" />
      <path d="m13 6 6 6-6 6" />
    </>
  ),
  shield: (
    <>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z" />
      <path d="m9 12 2 2 4-4" />
    </>
  ),
  microphone: (
    <>
      <rect x="8" y="3" width="8" height="12" rx="4" />
      <path d="M5 11a7 7 0 0 0 14 0M12 18v3M8 21h8" />
    </>
  ),
  stop: <rect x="6" y="6" width="12" height="12" rx="2" />,
  more: (
    <>
      <circle cx="5" cy="12" r="1" />
      <circle cx="12" cy="12" r="1" />
      <circle cx="19" cy="12" r="1" />
    </>
  ),
  pencil: (
    <>
      <path d="M17 3a2.8 2.8 0 0 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3Z" />
      <path d="m15 5 4 4" />
    </>
  ),
  lock: (
    <>
      <rect x="5" y="11" width="14" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </>
  ),
  undo: (
    <>
      <path d="M4 10h10a5 5 0 0 1 0 10h-4" />
      <path d="m8 6-4 4 4 4" />
    </>
  ),
  lab: (
    <>
      <path d="M9.4 2.8h5.2M10.6 2.8v6.4L5 19a1.7 1.7 0 0 0 1.5 2.5h11a1.7 1.7 0 0 0 1.5-2.5l-5.6-9.8V2.8" />
      <path d="M7.7 14.6h8.6" />
    </>
  ),
  scan: (
    <>
      <path d="M4 8.6V6.2a2.2 2.2 0 0 1 2.2-2.2h2.4M15.4 4h2.4A2.2 2.2 0 0 1 20 6.2v2.4M20 15.4v2.4a2.2 2.2 0 0 1-2.2 2.2h-2.4M8.6 20H6.2A2.2 2.2 0 0 1 4 17.8v-2.4" />
      <path d="M7.4 12h9.2" />
    </>
  ),
  consult: (
    <>
      <path d="M6.2 2.6h7.4l4.6 4.6v14.2H6.2z" />
      <path d="M13.6 2.6v4.6h4.6" />
      <circle cx="12.2" cy="12.6" r="1.9" />
      <path d="M9 18.3a3.3 3.3 0 0 1 6.4 0" />
    </>
  ),
  upload: (
    <>
      <path d="M6.2 2.6h7.4l4.6 4.6v14.2H6.2z" />
      <path d="M13.6 2.6v4.6h4.6" />
      <path d="M12.2 18.3v-5.8M9.8 14.8l2.4-2.4 2.4 2.4" />
    </>
  ),
  personPlus: (
    <>
      <circle cx="9.2" cy="8" r="3.5" />
      <path d="M3.2 19.4c0-3.3 2.7-5.5 6-5.5 1.4 0 2.7.4 3.7 1.1" />
      <path d="M17.6 13.2v6.6M14.3 16.5h6.6" />
    </>
  ),
  phone: (
    <path d="M7.2 3.6 9.7 8.1 8 10.2a12.2 12.2 0 0 0 5.8 5.8l2.1-1.7 4.5 2.5v3a1.6 1.6 0 0 1-1.8 1.6C10.4 20.5 3.5 13.6 2.6 5.4A1.6 1.6 0 0 1 4.2 3.6z" />
  ),
};

interface IconProps extends SVGProps<SVGSVGElement> {
  name: IconName;
}

export function Icon({ name, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      {...props}
    >
      {paths[name]}
    </svg>
  );
}
